import { createApi } from '@reduxjs/toolkit/query/react';
import { getHeaders } from 'helpers/utils';
import { baseUrl } from 'authConfig';
import { customFetchBaseQuery } from './customFetch';

export const bannerApi = createApi({
  reducerPath: 'bannerApi',
  tagTypes: ['Banner'],
  baseQuery: customFetchBaseQuery({ baseUrl }),
  endpoints: (builder) => ({
    getBanners: builder.mutation({
      query: ({ token }) => ({
        url: 'commondata/getbanners',
        headers: getHeaders(token),
        method: 'GET',
      }),
      invalidatesTags: () => [{ type: 'Banner', id: 'LIST' }],
    }),
  }),
});

export const { useGetBannersMutation } = bannerApi;
